module.exports = __webpack_public_path__ + "static/media/Gmail.895b5906.svg";